<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <el-button class="new-btn" @click="newOrder">
            <i class="el-icon-plus"></i>
            添加
          </el-button>
          <div class="right-search">
            <!-- <el-select class="right-select" v-model="reType">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select> -->
            <a class="head_span" @click="searchMonth">一月内</a>
            <el-input
              class="search-input"
              placeholder="请输入搜索内容"
              v-model="search_name"
              :header-cell-style="getRowClass"
              prefix-icon="el-icon-search" @keyup.enter.native="searchName">
            </el-input>
          </div>
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="name"
            label="名称">
          </el-table-column>
          <el-table-column
            prop="model"
            label="型号">
          </el-table-column>
          <el-table-column
            prop="cert_code"
            label="证书编号">
          </el-table-column>
          <el-table-column
            prop="next_date"
            label="到期日期">
          </el-table-column>
          <el-table-column
            prop="measure"
            label="范围">
          </el-table-column>
          <el-table-column
            prop="grade"
            label="等级">
          </el-table-column>
          <el-table-column label="操作" class="btn-container">
            <template slot-scope="scope" class="btn-container">
              <el-button
                class="edit-btn"
                @click="handleEdit(scope.row, scope.$index)">
                <i class="el-icon-edit-outline"></i>
                修改
                </el-button>
                <el-button
                class="delete-btn"
                @click="handleDelete(scope.$index, scope.row)">
                <i class="el-icon-delete"></i>
                删除
                </el-button>                
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加 标准计量器具-->
    <el-dialog
      :title="ruleAdd.title"
      class="big-dialog-container"
      :visible.sync="dialogUpdate">
      <el-form class="form-container" :model="ruleAdd"  :rules="rules" ref="ruleAdd">
        <div >
          <el-form-item class="input-list" label="名称" prop="name">
            <el-input type="text" placeholder="请输入名称" v-model="ruleAdd.name"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="型号" prop="model">
            <el-input type="text" placeholder="请输入型号" v-model="ruleAdd.model"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="设备编号" prop="asset_code">
            <el-input type="text" placeholder="设备编号" v-model="ruleAdd.asset_code"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="证书编号" prop="cert_code">
            <el-input type="text" placeholder="证书编号" v-model="ruleAdd.cert_code"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="证书日期" prop="cert_date">
            <el-date-picker
              class="date-input"
              type="date"
              v-model="ruleAdd.cert_date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="input-list" label="到期日期" prop="next_date">
            <el-date-picker
              class="date-input"
              type="date"
              v-model="ruleAdd.next_date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="input-list" label="测量范围" prop="measure">
            <el-input type="text" placeholder="请输入测量范围" v-model="ruleAdd.measure"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="允许误差" prop="grade">
            <el-input type="text" placeholder="请输入不确定度/准确度/最大允许误差" v-model="ruleAdd.grade"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="出厂编号" prop="vendor_code">
            <el-input type="text" placeholder="请输入出厂编号" v-model="ruleAdd.vendor_code"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="生产厂家" prop="vendor">
            <el-input type="text" placeholder="请输入生产厂家" v-model="ruleAdd.vendor"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="器具类型" prop="type">
            <!-- <el-input type="password" placeholder="请输入密码" v-model="ruleAdd.password"></el-input> -->
            <el-select class="options-select" v-model="ruleAdd.std_equip_type" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.equip_type_id"
                :label="item.type_name"
                :value="item.equip_type_id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item class="input-list" label="溯源方式" prop="type">
            <el-select class="options-select" v-model="ruleAdd.roots_type" placeholder="请选择">
              <el-option
                v-for="item in root_options"
                :key="item.root_type_id"
                :label="item.type_name"
                :value="item.root_type_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="input-list" label="溯源单位" prop="type">
            <!-- <el-input type="password" placeholder="请输入密码" v-model="ruleAdd.password"></el-input> -->
            <el-select class="options-select" v-model="ruleAdd.cert_lab_id" placeholder="请选择">
              <el-option
                v-for="item in labs"
                :key="item.lab_id"
                :label="item.name"
                :value="item.lab_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="input-list" label="购买日期" prop="buy_date">
            <el-date-picker
              class="date-input"
              type="date"
              v-model="ruleAdd.buy_date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="input-list" label="启用日期" prop="use_date">
            <el-date-picker
              class="date-input"
              type="date"
              v-model="ruleAdd.use_date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"></el-date-picker>
          </el-form-item>
<!--           <el-form-item class="input-list" label="提示">
            <span class="red-txt">您只能创建与您能力匹配的标准器具</span>
          </el-form-item> -->
          <el-form-item class="btn-list">
            <el-button class="btn-save" @click="submitForm('ruleAdd')">保存</el-button>
          </el-form-item>
        </div>
        </el-form>
    </el-dialog>
    <!-- 删除的弹窗框 start -->
    <delete-box @delete="deleteData" v-if="deleteShow"></delete-box>
    <!-- 删除的弹出框 end -->
  </div>
</template>

<script type='text/ecmascript-6'>
import DeleteBox from 'components/DeleteBox.vue'
import moment from 'moment'
import { deviceName, certCode} from 'common/js/loginValidate'
/* import { getCookie } from 'common/js/mUtils.js' */
export default {
  data() {
    return {
      empty: '没有标准器具管理信息',
      page: 1,
      limit: 10,
      tableData: [],
      total: 0,
      dialogUpdate: false,
      ruleAdd: {}, // 修改标准器具管理
      rules: {
        name: [
          { validator: deviceName, trigger: ['blur'] }
        ],
        cert_code: [
          { validator: certCode, trigger: 'blur'}
        ]
      },
      options: [],
      root_options: [],
      labs: [],
      search_name: '',
      month_state: false,
      deleteShow: false,
      search_state: false
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    searchMonth() {
      let that = this
      if (that.month_state == false) {
        that.month_state = true
        that.page = 1
        that.search_state = false
      }
      that.$api.getStdEquipsMonth({
        page_num: (that.page - 1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.data.length > 0) {
          that.tableData = res.data.data
          that.total = Number(res.data.total)
        } else {
          that.tableData = res.data.data
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    initData() {
      let that = this
      that.$api.getStdEquips({
        page_num: (that.page - 1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.data.length > 0) {
          that.tableData = res.data.data
          that.total = Number(res.data.total)
        } else {
          that.tableData = res.data.data
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      if (this.month_state) {
        this.searchMonth()
      }
      else if (this.search_state) {
        this.searchName()
      } else {
        this.initData()
      }
    },
    newOrder() {
      /* this.dialogUpdate = true */
      this.getType()
    },
    getType () {
      let that = this
      that.ruleAdd = {}
      this.$api.getStdEquipType({
      }).then(res => {
        if (res.data.equip_type.length > 0) {
          that.options = res.data.equip_type
          that.root_options = res.data.roots_type
          that.dialogUpdate = true
          that.ruleAdd={
            title: '添加标准计量器具管理',
            asset_code:'',
            roots_type: that.root_options[0].root_type_id,
            cert_date: moment(new Date()).format('YYYY-MM-DD'),
            next_date: moment(new Date()).add(1,'year').add(-1,'day').format('YYYY-MM-DD'),
            std_equip_type: that.options[0].equip_type_id,
            measure: '',
            grade : '',
            model: '',
            vendor: '',
            vendor_code: '',
            name: '',
            cert_code: '',
            cert_lab_id: '',
            buy_date:moment(new Date()).format('YYYY-MM-DD'),
            use_date:moment(new Date()).format('YYYY-MM-DD')
          }
        } else {
          that.$message({
            type: 'error',
            message: '分类获取错误！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      }).then(() => {
        that.getAllLab()
      })
    },
    getAllLab() { // 获取检测机构的选择
      let that = this
      that.$api.getAllLab({}).then(res => {
        if (res.data.length > 0) {
          that.labs = [...res.data]
        } else {
          that.$message({
            type: 'error',
            message: '检测机构获取错误！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    // 新增规格保存
    submitForm(formName) { // 修改后 点击保存
      let that = this
      if (!that.ruleAdd.cert_lab_id) {
        that.$message({
          type: 'error',
          message: '请选择检测机构！',
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(that.ruleAdd.equip_id) {
            that.updateStdEquip()
          } else {
            that.addStdEquip()
          }
        }
      })
    },
    updateStdEquip() { // 修改 标准计量器具
      var that = this;
      that.$api.updateStdEquip({
        ...that.ruleAdd,
      }).then(res => {
        that.dialogUpdate = false
        if (res.data.msg === true) {
          that.$message({
            type: 'success',
            message: '标准器具管理修改成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          if (that.month_state) {
            that.searchMonth()
          }
          else if (that.search_state) {
            that.searchName()
          } else {
            that.initData()
          }
          /* 修改成功 */
          /* that.tableData[that.dataIndex] = {
            ...that.ruleAdd,
            next_date: moment(new Date(that.ruleAdd.next_date)).format('YYYY-MM-DD')
          } */
          /* that.tableData[that.dataIndex].name = that.ruleAdd.name
          that.tableData[that.dataIndex].code = that.ruleAdd.code
          let arr = that.options.filter(item => {
            return item.device_type == that.ruleAdd.type
          })
          that.tableData[that.dataIndex].type_name= arr[0].type_name */
        } else {
          that.$message({
            type: 'error',
            message: res.data.error,
            customClass: 'msg-position',
            showClose: true
          })
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    addStdEquip() { // 添加标准计量器具
      var that = this
      that.$api.addStdEquip({
        ...that.ruleAdd,
      }).then(res => {
        that.dialogUpdate = false
        if (res.data.msg === true) {
          that.$message({
            type: 'success',
            message: '标准器具管理添加成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          that.initData()
        } else {
          that.$message({
            type: 'error',
            message: res.data.error,
            customClass: 'msg-position',
            showClose: true
          })
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    // 修改 
    handleEdit (row, index) {
      let that = this
      that.ruleAdd = {}
      this.$api.getStdEquipType({
      }).then(res => {
        if (res.data.equip_type.length > 0) {
          that.options = res.data.equip_type
          that.root_options = res.data.roots_type
          that.dialogUpdate = true
          that.dialogUpdate = true
          that.dataIndex = index
          that.ruleAdd = {
            title: '修改标准器具管理',
            name: row.name,
            model: row.model,
            asset_code: row.asset_code,
            cert_code: row.cert_code,
            measure: row.measure,
            grade: row.grade,
            cert_date: row.cert_date,
            next_date: row.next_date,
            vendor: row.vendor,
            vendor_code: row.vendor_code,
            std_equip_type: row.std_equip_type,
            equip_id: row.equip_id,
            cert_lab_id: row.cert_lab_id,
            roots_type: row.roots_type,
            buy_date:row.buy_date,
            use_date:row.use_date
          }
        } else {
          that.$message({
            type: 'error',
            message: '分类获取错误！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      }).then(() => {
        that.getAllLab()
      })
    },
    handleDelete (index,row) { // 点击删除按钮
      let that = this
      that.deleteIndex = index
      that.deleteRow = row
      that.deleteShow = true
    },
    deleteData (val) { // 点击删除的弹出框
      let that = this
      if (val === 'cancle') {
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
      if (val === 'sure') {
        that.delete(that.deleteIndex, that.deleteRow.equip_id)
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
    },    
    delete(index,equip_id){
      let that = this
      this.$api.deleteStdEquip({
        equip_id: equip_id
      }).then(res => {
        if (res.data.msg === true) {
          /* that.tableData.splice(index, 1)
          that.total = that.total - 1 */
          that.initData()
          that.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '删除失败',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })  
    },
    searchName () {
      let that = this
      if (!that.search_name) {
        that.$message({
          type: 'error',
          message: `请输入搜索内容`,
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      if (!that.search_state) {
        that.search_state = true
        that.page = 1
        that.month_state = false
      }
      that.$api.searchEquip({
        search: that.search_name,
        page_num: (that.page - 1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.data.length > 0) {
          that.tableData = res.data.data
          that.total = Number(res.data.total)
        } else {
          /* this.tableData = []
          that.total = 0 */
          that.$message({
            type: 'error',
            message: `没有该规程信息`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    }
  },
  components: {
    DeleteBox
  }  
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/mixin.styl'
@import '~common/stylus/box.styl'
@import '~common/stylus/big-dialog.styl'
</style>
